import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

export const MAX_MESSAGE_CONTENT_WIDTH = 446

const useStyles = makeStyles(theme => ({
	messageContent: {
		display: "inline-block",
		height: "auto",
		width: "auto",
		position: "relative",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		padding: theme.spacing(3, 2, 1, 2),
		borderRadius: theme.spacing(1),
		boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.25)",
		maxWidth: MAX_MESSAGE_CONTENT_WIDTH,
		wordBreak: "break-word",
		whiteSpace: "break-spaces",
		color: colors.gray[700],
		fontSize: "14px",
		lineHeight: "24px"
	}
}))

export default useStyles
